// Shared-component strings, namespaced as 'components.<componentName>.<key>'.
// Auto-compiled from the i18n-full-app-coverage workflow run.
export default {
  'components.cleanTextContextMenu.copy': 'Copy clean text',
  'components.cleanTextContextMenu.copied': 'Clean text copied',
  'components.cleanTextContextMenu.failed': 'Could not copy text. Please try again.',
  'components.addToMattersPopover.selectMattersLabel': 'Select matter(s):',
  'components.addToMattersPopover.searchPlaceholder': 'Search matters...',
  'components.addToMattersPopover.updateSuccess': 'Matters updated successfully',
  'components.addToMattersPopover.updateError': 'Failed to update matters',
  'components.billingRequiredOverlay.defaultMessage':
    'Your organisation billing requires attention before this action can continue. Please contact your organisation admin.',
  'components.billingRequiredOverlay.title': 'Billing required',
  'components.billingRequiredOverlay.manageBillingButton': 'Manage billing',
  'components.chat.jsonResponseTitle': 'JSON Response',
  'components.chat.dataOpenedInNewTab': 'Data opened in new tab',
  'components.chat.textResponseTitle': 'Text Response',
  'components.chat.contentOpenedInNewTab': 'Content opened in new tab',
  'components.chat.fileOpenedInNewTab': 'File opened in new tab',
  'components.chat.failedToOpenNewTab': 'Failed to open new tab',
  'components.chat.failedToFetchUrl': 'Failed to fetch URL: {message}',
  'components.chat.referenceDocumentFallback': 'Reference document',
  'components.chat.sourcesCount': 'Sources ({count})',
  'components.chat.referencesCount': '{count} references',
  'components.chat.htmlContentTitle': 'HTML Content',
  'components.chat.showMoreLines': 'Show more ({count} lines)',
  'components.chatWidget.waitingMessage.justAMoment': 'Just a moment...',
  'components.chatWidget.waitingMessage.fetchingThatForYou': 'Fetching that for you...',
  'components.chatWidget.waitingMessage.hangTight': "Hang tight, I'm on it...",
  'components.chatWidget.waitingMessage.letMeCheck': 'Let me check...',
  'components.chatWidget.waitingMessage.thisWillJustTakeASecond': 'This will just take a second...',
  'components.chatWidget.closeChatAriaLabel': 'Close chat',
  'components.chatWidget.openChatAriaLabel': 'Open chat',
  'components.chatWidget.processingTooltip': 'Chat will be available once processing is done',
  'components.chatWidget.messageCopied': 'Message copied!',
  'components.chatWidget.copyMessageFailed': 'Failed to copy message',
  'components.chatWidget.header.title': 'Chat',
  'components.chatWidget.emptyState.title': 'How can I help?',
  'components.chatWidget.inputPlaceholder': 'Type a message...',
  'components.chatWidget.showMoreLines': 'Show more ({count} lines)',
  'components.chatWidget.invalidFileUrl': 'Invalid or missing file URL',
  'components.chatWidget.fileDownloadedSuccessfully': 'File downloaded successfully',
  'components.chatWidget.fileDownloadFailed': 'Failed to download file: {message}',
  'components.chatWidget.unnamedFile': 'file',
  'components.chatWidget.attachmentImageAlt': 'attachment',
  'components.checklistCard.heading': 'Checklist',
  'components.downloadLoadingMask.downloading': 'Downloading...',
  'components.emlViewer.fromLabel': 'From:',
  'components.emlViewer.toLabel': 'To:',
  'components.emlViewer.ccLabel': 'Cc:',
  'components.emlViewer.dateLabel': 'Date:',
  'components.emlViewer.attachmentsLabel': 'Attachments:',
  'components.filesSidePanel.favoritesButton': 'Favorites',
  'components.filesSidePanel.historyButton': 'History',
  'components.filesSidePanel.untitledPlaceholder': '(Untitled)',
  'components.filesSidePanel.membersPopoverTitle': 'Members',
  'components.filesSidePanel.ownerTag': 'Owner',
  'components.filesSidePanel.modifyGroupTooltip': 'Modify Group',
  'components.filesSidePanel.privateGroupWarningTooltip': 'Less safe: Visible by your group.',
  'components.filesSidePanel.firmWideWarningTooltip': 'Very unsafe: Visible by your firm.',
  'components.filesSidePanel.publicWarningTooltip': 'Very unsafe: Visible by everyone.',
  'components.filesSidePanel.sortByDateLabel': 'Sort by Date (New to Old)',
  'components.filesSidePanel.sortAlphabeticallyLabel': 'Sort Alphabetically (A-Z)',
  'components.gettingStartedTour.insiderHero.openLinkLabel': 'Open A&GEL Insider',
  'components.gettingStartedTour.insiderHero.logoAlt': 'A&GEL Insider',
  'components.gettingStartedTour.insiderHero.heroTitle': 'Learning new tools takes time',
  'components.gettingStartedTour.insiderHero.basicsCard.copy': 'Everything you need from day one.',
  'components.gettingStartedTour.insiderHero.basicsCard.cta': 'Start with the Basics',
  'components.gettingStartedTour.insiderHero.learnMoreCard.copy':
    'Power features if you want to go further.',
  'components.gettingStartedTour.insiderHero.learnMoreCard.cta': 'Learn More',
  'components.gettingStartedTour.insiderHero.whatsNewCard.copy': 'Recent launches and updates.',
  'components.gettingStartedTour.insiderHero.whatsNewCard.cta': "What's New",
  'components.gettingStartedTour.insiderHero.marinaAlt': 'Marina skyline',
  'components.gettingStartedTour.insiderHero.featuredArticleLabel': 'Featured Article',
  'components.gettingStartedTour.insiderHero.filesUpload.title': 'Grammar of Use',
  'components.gettingStartedTour.insiderHero.filesUpload.description':
    'We are introducing a new form of instructional content called Grammar of Use. The first edition is a general guide for new users, with plenty of examples and hyperlinks to the relevant features',
  'components.gettingStartedTour.insiderHero.filesUpload.cta': 'See More',
  'components.gettingStartedTour.allCompleted.title': "You've completed the full A&GEL tour!",
  'components.gettingStartedTour.allCompleted.redoButton': 'Redo tour',
  'components.gettingStartedTour.heading': 'Getting Started',
  'components.gettingStartedTour.tourStyles.stepIndicator': 'Step {current} of {total}',
  'components.gettingStartedTour.tourStyles.nextDefault': 'Next →',
  'components.gettingStartedTour.chatTour.step1.title':
    "We've loaded a sample NDA for you. Click Context to see it.",
  'components.gettingStartedTour.chatTour.step1.text':
    'This is where you manage which documents A&GEL references when answering.',
  'components.gettingStartedTour.chatTour.step2.title': "Here's your loaded document.",
  'components.gettingStartedTour.chatTour.step2.text':
    'You can upload files or select from your Vault. Close the panel when ready.',
  'components.gettingStartedTour.chatTour.step2.nextLabel': 'Close & Continue →',
  'components.gettingStartedTour.chatTour.step3.title':
    "We've prepared a question for you. Click Send to ask about the NDA.",
  'components.gettingStartedTour.chatTour.sampleQuestionDisplay':
    'What are the confidentiality obligations in this agreement?',
  'components.gettingStartedTour.chatTour.step4.title':
    'Great answer! Now click a reference number (e.g. [1]) to see the source document.',
  'components.gettingStartedTour.chatTour.step4.text':
    'References link back to the exact part of the document the AI used.',
  'components.gettingStartedTour.chatTour.completeModal.title': 'Nice work!',
  'components.gettingStartedTour.chatTour.completeModal.description':
    'You asked your first question in Chat and got a cited answer.',
  'components.gettingStartedTour.tourComplete.progressText':
    '{completedCount} of 5 features completed',
  'components.gettingStartedTour.tourComplete.completeButton': 'Complete',
  'components.gettingStartedTour.tourComplete.continueButton': 'Continue to {title} →',
  'components.gettingStartedTour.playbookTour.completeModal.title': 'Well done!',
  'components.gettingStartedTour.playbookTour.completeModal.description':
    'You applied amendments with Workstudio.',
  'components.gettingStartedTour.playbookTour.step1.title':
    "We've loaded a sample vendor agreement that needs amendments.",
  'components.gettingStartedTour.playbookTour.step1.text':
    "You're the vendor (Pand.ai) requesting more favorable terms from the client.",
  'components.gettingStartedTour.playbookTour.step1.openingLabel': 'Opening…',
  'components.gettingStartedTour.playbookTour.step1.openSampleLabel': 'Open sample →',
  'components.gettingStartedTour.playbookTour.step2.title': "We've drafted 3 amendment requests:",
  'components.gettingStartedTour.playbookTour.step2.item1': '• Joint IP ownership (Clause 17)',
  'components.gettingStartedTour.playbookTour.step2.item2': '• Add 14-day cure period (Clause 8)',
  'components.gettingStartedTour.playbookTour.step2.item3': '• Narrow non-compete (Clause 27)',
  'components.gettingStartedTour.playbookTour.step2.text':
    'Multi-step mode processes each one in parallel for faster results.',
  'components.gettingStartedTour.playbookTour.step3.title': 'Click Send to generate amendments.',
  'components.gettingStartedTour.playbookTour.step3.text':
    'A&GEL will show tracked changes that you can accept, reject, or download.',
  'components.gettingStartedTour.playbookTour.step4.title':
    'Here are the amendments A&GEL drafted from your prompt.',
  'components.gettingStartedTour.playbookTour.step4.text':
    'Each card shows the original text and the proposed change.',
  'components.gettingStartedTour.playbookTour.step5.title':
    'Review this amendment and accept or reject it.',
  'components.gettingStartedTour.playbookTour.step5.text':
    'You can repeat this for the rest later.',
  'components.gettingStartedTour.reviewTour.completeModal.title': 'Impressive!',
  'components.gettingStartedTour.reviewTour.completeModal.description':
    'You created a Question List and reviewed documents with it.',
  'components.gettingStartedTour.reviewTour.step1.title':
    'Review answers your questions across multiple documents using Question Lists.',
  'components.gettingStartedTour.reviewTour.step1.text':
    'You can create your own or use existing ones.',
  'components.gettingStartedTour.reviewTour.step2.title':
    'Browse pre-built Question Lists by category.',
  'components.gettingStartedTour.reviewTour.step3.title':
    "Let's create your own. Click here to start a new Question List.",
  'components.gettingStartedTour.reviewTour.step4.title': 'Pick a category to organise your list.',
  'components.gettingStartedTour.reviewTour.step5.title':
    'Here are some sample questions, added to your list as editable rows.',
  'components.gettingStartedTour.reviewTour.step6.title':
    'Your questions appear here as editable rows. You can remove them anytime or add section to group them.',
  'components.gettingStartedTour.reviewTour.step7.title':
    'Describe what this list is for — cater it to your needs.',
  'components.gettingStartedTour.reviewTour.step8.title':
    'Tune how the AI answers — tone, format, level of detail.',
  'components.gettingStartedTour.reviewTour.step9.title': 'Save your list to use it on documents.',
  'components.gettingStartedTour.reviewTour.step10.title':
    "We've loaded some sample documents for you to experiment with.",
  'components.gettingStartedTour.reviewTour.step10.text':
    'Your Question List is ready to run against them.',
  'components.gettingStartedTour.reviewTour.step11.title':
    'Hit Submit to run the review across all documents.',
  'components.gettingStartedTour.reviewTour.step12.title':
    'Each row is a question, each column is a document. Answers are extracted automatically.',
  'components.gettingStartedTour.reviewTour.step13.title':
    'Click any answer to see exactly where it came from.',
  'components.gettingStartedTour.reviewTour.step14.title':
    'Click a reference number to jump to the exact passage in the source document.',
  'components.gettingStartedTour.reviewTour.step15.title':
    "That's the full Review flow — sources are always one click away. You're done!",
  'components.gettingStartedTour.reviewTour.step15.nextLabel': 'Finish',
  'components.gettingStartedTour.scribeTour.completeModal.title': 'Well done!',
  'components.gettingStartedTour.scribeTour.completeModal.description':
    'You transcribed audio with Scribe.',
  'components.gettingStartedTour.scribeTour.step1.title':
    "Select what you'll use the transcription for.",
  'components.gettingStartedTour.scribeTour.step1.text':
    'This helps A&GEL format the output. "Meeting Notes" is already selected.',
  'components.gettingStartedTour.scribeTour.step2.title': 'Language is set to "Auto-detect".',
  'components.gettingStartedTour.scribeTour.step2.text':
    'You can also enable Live Translation to see translations in real-time.',
  'components.gettingStartedTour.scribeTour.step3.title':
    'Click the record button, or upload an existing audio file.',
  'components.gettingStartedTour.scribeTour.step4.title':
    "Click Stop when you're ready to save the transcript.",
  'components.gettingStartedTour.scribeTour.step5.title':
    'Type a name for your transcript, then click Save.',
  'components.gettingStartedTour.scribeTour.step6.title':
    'Click any transcript line to play the audio from that point.',
  'components.gettingStartedTour.scribeTour.step7.title': 'Click Edit to modify the transcript.',
  'components.gettingStartedTour.scribeTour.step7.text': 'Your changes appear in gold.',
  'components.gettingStartedTour.scribeTour.step8.title': 'Click Save to keep your changes.',
  'components.gettingStartedTour.scribeTour.step8.text': 'Your edits appear in gold before saving.',
  'components.gettingStartedTour.searchTour.completeModal.title': 'Great job!',
  'components.gettingStartedTour.searchTour.completeModal.description':
    'You searched across documents and found relevant clauses.',
  'components.gettingStartedTour.searchTour.step1.title': "We've prepared a search query for you.",
  'components.gettingStartedTour.searchTour.step1.text':
    'Click Search or press Enter to find matching clauses.',
  'components.gettingStartedTour.searchTour.step2.title':
    "Here's a match from the NDA. Click the document to view all matches inside it.",
  'components.gettingStartedTour.searchTour.step3.title':
    'Click any chunk to jump to that section in the document.',
  'components.gettingStartedTour.searchTour.step3.text':
    'On the left you see matched excerpts. On the right is the full document with highlighted keywords.',
  'components.gettingStartedTour.tourButton.label': 'Tour',
  'components.gettingStartedTour.tourCompleteModal.features.chat': 'Ask questions in Chat',
  'components.gettingStartedTour.tourCompleteModal.features.search': 'Search across documents',
  'components.gettingStartedTour.tourCompleteModal.features.scribe': 'Transcribe with Scribe',
  'components.gettingStartedTour.tourCompleteModal.features.review': 'Analyse with Review',
  'components.gettingStartedTour.tourCompleteModal.features.playbook':
    'Apply amendments in Workstudio',
  'components.gettingStartedTour.tourCompleteModal.title': "You're all set!",
  'components.gettingStartedTour.tourCompleteModal.subtitle':
    "You've completed the A&GEL tour and learned how to:",
  'components.gettingStartedTour.tourCompleteModal.progressText': '5 of 5 features completed',
  'components.gettingStartedTour.tourCompleteModal.ctaButton': 'Start Using A&GEL →',
  'components.gettingStartedTour.tourCompleteModal.userGuidePrefix': 'Need help? Visit the ',
  'components.gettingStartedTour.tourCompleteModal.userGuideLabel': 'User Guide',
  'components.lLMMetrics.status.fast': 'FAST',
  'components.lLMMetrics.status.slow': 'SLOW',
  'components.lLMMetrics.status.busy': 'BUSY',
  'components.lLMMetrics.status.pending': 'PENDING',
  'components.lLMMetrics.status.loading': 'LOADING',
  'components.lLMMetrics.metricBox.defaultChartLabel': 'Value',
  'components.management.passwordModal.usernameColumn': 'Username',
  'components.management.passwordModal.passwordColumn': 'Password',
  'components.management.passwordModal.createHeader':
    'You have successfully created user with credentials below:',
  'components.management.passwordModal.emailChangeHeader':
    'You have successfully changed the user email. New credentials below:',
  'components.management.passwordModal.changePasswordNotice':
    '*The user will have to change their password after their initial login',
  'components.menuPanel.untitledItem': '(Untitled)',
  'components.menuPanel.renameFailed': 'Failed to rename',
  'components.menuPanel.deleteConfirm.title': 'Delete History Item',
  'components.menuPanel.deleteConfirm.content':
    'Are you sure you want to delete this history item? This action cannot be undone.',
  'components.menuPanel.deleteConfirm.createdLabel': 'Created:',
  'components.menuPanel.deleteSuccess': 'History item deleted successfully',
  'components.menuPanel.deleteFailed': 'Failed to delete history item',
  'components.menuPanel.searchHistoryButton': 'Search History',
  'components.menuPanel.historyLabel': 'History',
  'components.menuPanel.showAllButton': 'Show All',
  'components.menuPanel.showFavoritesButton': 'Show Favorites',
  'components.menuPanel.endOfListMessage': '- This is the end -',
  'components.message.enhanceGpt.modalTitle': 'Enhance GPT Response',
  'components.message.enhanceGpt.successMessage': 'New response recorded',
  'components.message.enhanceGpt.questionLabel': 'Question: {question}',
  'components.message.enhanceGpt.answerLabel': 'Answer',
  'components.message.postback.clickedLabel': 'Clicked:',
  'components.message.postback.chatbotButtonFallback': 'Chatbot Button',
  'components.message.locationLabel': 'Location',
  'components.message.stickerLabel': 'Sticker',
  'components.message.audiosLabel': 'Audios',
  'components.message.imagesLabel': 'Images',
  'components.message.videosLabel': 'Videos',
  'components.msgViewer.fromLabel': 'From:',
  'components.msgViewer.toLabel': 'To:',
  'components.msgViewer.attachmentsLabel': 'Attachments:',
  'components.pdfViewerWithHighlight.renderError': 'Failed to render PDF',
  'components.promptSelector.copySuccess': 'Prompt copied!',
  'components.promptSelector.copyError': 'Failed to copy prompt',
  'components.promptSelector.noResultsFiltered': 'No prompts found matching your filters',
  'components.promptSelector.startTyping': 'Start typing to search prompts',
  'components.promptSelector.promptLoaded': 'Prompt loaded to chat input!',
  'components.promptSelector.untitledPrompt': 'Untitled Prompt',
  'components.promptSelector.actionPlaceholder': 'Action',
  'components.promptSelector.actionOption.summarise': 'Summarise',
  'components.promptSelector.actionOption.review': 'Review',
  'components.promptSelector.actionOption.amend': 'Amend',
  'components.promptSelector.actionOption.draft': 'Draft',
  'components.promptSelector.actionOption.redFlagging': 'Red-flagging',
  'components.promptSelector.audiencePlaceholder': 'Audience',
  'components.promptSelector.audienceOption.personal': 'Personal',
  'components.promptSelector.audienceOption.group': 'Group',
  'components.promptSelector.audienceOption.public': 'Public',
  'components.promptSelector.selectPromptHint': 'Select a prompt to load it into input box',
  'components.promptSelector.usePromptButton': 'Use Prompt',
  'components.promptSelector.authorLabel': 'Author',
  'components.promptSelector.promptLabel': 'Prompt',
  'components.promptSelector.tagsLabel': 'Tags',
  'components.promptSelector.documentsAttached': '{count} document(s) will be attached',
  'components.questionListSelection.untitledQuestionList': '(Untitled)',
  'components.questionListSelection.questionCount': '{count} Questions',
  'components.questionListSelection.accessPublicTag': 'Public',
  'components.questionListSelection.accessFirmTag': 'Firm',
  'components.questionListSelection.accessGroupTag': 'Private group',
  'components.questionListSelection.viewLess': 'View Less',
  'components.questionListSelection.viewAll': 'View All',
  'components.questionListSelection.whatsNewButton': "What's New",
  'components.questionListSelection.tourTooltip': 'Take a tour',
  'components.questionListSelection.tourButton': 'Tour',
  'components.questionListSelection.sortMostPopular': 'Sort: Most Popular',
  'components.questionListSelection.sortNameAsc': 'Sort: Name A-Z',
  'components.questionListSelection.sortNameDesc': 'Sort: Name Z-A',
  'components.questionListSelection.filterByAudiencePlaceholder': 'Filter by Audience',
  'components.questionListSelection.audienceOptionPersonal': 'Personal',
  'components.questionListSelection.audienceOptionPublic': 'Public',
  'components.questionListSelection.filterByAuthorPlaceholder': 'Filter by Author',
  'components.reference.unknownAuthor': 'Unknown',
  'components.reference.timeAgo.justNow': 'Just now',
  'components.reference.timeAgo.minutesAgo':
    '{count, plural, one {# minute ago} other {# minutes ago}}',
  'components.reference.timeAgo.hoursAgo': '{count, plural, one {# hour ago} other {# hours ago}}',
  'components.reference.timeAgo.daysAgo': '{count, plural, one {# day ago} other {# days ago}}',
  'components.reference.openCellDetails': 'Open cell details',
  'components.reference.answerLabel': 'Answer: ',
  'components.reference.explanationLabel': 'Explanation',
  'components.reference.verifiedLabel': 'Verified',
  'components.reference.verifyLabel': 'Verify',
  'components.reference.pleaseEnterComment': 'Please enter a comment',
  'components.reference.matrixIdRequired':
    'Matrix ID is required. Please ensure matrixId prop is passed to Reference component.',
  'components.reference.commentAddedSuccess': 'Comment added successfully',
  'components.reference.failedToAddComment': 'Failed to add comment',
  'components.reference.commentUpdatedSuccess': 'Comment updated successfully',
  'components.reference.updateOwnCommentsOnly': 'You can only update your own comments',
  'components.reference.failedToUpdateComment': 'Failed to update comment',
  'components.reference.commentDeletedSuccess': 'Comment deleted successfully',
  'components.reference.deleteOwnCommentsOnly': 'You can only delete your own comments',
  'components.reference.failedToDeleteComment': 'Failed to delete comment',
  'components.reference.deleteComment.title': 'Delete comment',
  'components.reference.deleteComment.description': 'Are you sure you want to delete this comment?',
  'components.reference.addCommentPlaceholder': 'Add a comment...',
  'components.reference.cellsSelected':
    '{count, plural, one {# cell selected.} other {# cells selected.}}',
  'components.reference.selectCellAriaLabel': 'Select cell',
  'components.reference.selectQuestionRowAriaLabel': 'Select question row',
  'components.reference.selectDocumentColumnAriaLabel': 'Select document column',
  'components.reference.selectDocumentRowAriaLabel': 'Select document row',
  'components.reference.selectQuestionColumnAriaLabel': 'Select question column',
  'components.reference.documentsHeader': 'Documents',
  'components.reference.addRow': 'Add Row',
  'components.reference.addColumn': 'Add Column',
  'components.reference.inverse': 'Inverse',
  'components.reference.showAllColumns': 'Show All Columns',
  'components.reference.showAllRows': 'Show All Rows',
  'components.reference.resetView': 'Reset View',
  'components.reference.summaryView': 'Summary View',
  'components.reference.exactQuote': 'Source',
  'components.reference.exactQuoteView': 'Source View',
  'components.reference.detailedView': 'Detailed View',
  'components.reference.exitSelectMode': 'Exit',
  'components.reference.chatWithSelectedOutput': 'Chat with Selected Output',
  'components.reference.selectCells': 'Select Cells',
  'components.referencePopover.fileLinkUnavailable': 'File link is unavailable',
  'components.referencePopover.failedToOpenNewTab': 'Failed to open new tab',
  'components.referencePopover.failedToOpenFile': 'Failed to open file',
  'components.referencePopover.openInNewTab': 'Open document in new tab ↗',
  'components.rightContent.organisationSwitcher.switching': 'Switching organisation...',
  'components.rightContent.organisationSwitcher.switchSuccess':
    'Switched organisation successfully',
  'components.rightContent.organisationSwitcher.switchNoToken':
    'Switching organisation did not return new token',
  'components.rightContent.organisationSwitcher.switchError': 'Failed to switch organisation',
  'components.rightContent.organisationSwitcher.unknownOrg': 'Unknown Org',
  'components.rightContent.organisationSwitcher.defaultLabel': 'Org',
  'components.rightContent.organisationSwitcher.tooltipFallback': 'Switch Organisation',
  'components.rightContent.userGuideButton.label': 'A&GEL Insider',
  'components.rightContent.angelTeamsButton.label': 'Contact Us',
  'components.rightContent.reportBug.label': 'Report a bug',
  'components.rightContent.reportBug.modalDescription':
    "Tell us what you've encountered by filling in the form below.",
  'components.rightContent.reportBug.contactSectionTitle': 'Contact',
  'components.rightContent.reportBug.bugDescriptionSectionTitle': 'Bug Description',
  'components.rightContent.reportBug.environmentSectionTitle': 'Environment',
  'components.rightContent.reportBug.namePlaceholder': 'Enter your name',
  'components.rightContent.reportBug.nameRequired': 'Please enter your name',
  'components.rightContent.reportBug.emailLabel': 'Email',
  'components.rightContent.reportBug.emailPlaceholder': 'Enter your email',
  'components.rightContent.reportBug.emailRequired': 'Please enter your email',
  'components.rightContent.reportBug.emailInvalid': 'Please enter a valid email',
  'components.rightContent.reportBug.locationLabel': 'Where was the bug found?',
  'components.rightContent.reportBug.locationPlaceholder': 'Select Function',
  'components.rightContent.reportBug.locationRequired': 'Please specify where the bug was found',
  'components.rightContent.reportBug.descriptionLabel': 'Describe the issue',
  'components.rightContent.reportBug.descriptionRequired': 'Please describe the issue',
  'components.rightContent.reportBug.filesLabel': 'Screenshots or Recordings',
  'components.rightContent.reportBug.uploadText': 'Click or drag to upload',
  'components.rightContent.reportBug.fileSizeKb': '{size} KB',
  'components.rightContent.reportBug.removeFile': 'Remove {fileName}',
  'components.rightContent.reportBug.deviceLabel': 'Device',
  'components.rightContent.reportBug.devicePlaceholder': 'MacBook Pro M1 2021',
  'components.rightContent.reportBug.deviceRequired': 'Please specify your device',
  'components.rightContent.reportBug.osLabel': 'Operating system and version',
  'components.rightContent.reportBug.osPlaceholder': 'macOS Sequoia 15.1',
  'components.rightContent.reportBug.osRequired': 'Please specify your OS',
  'components.rightContent.reportBug.browserLabel': 'Browser',
  'components.rightContent.reportBug.browserPlaceholder': 'Select Browser',
  'components.rightContent.reportBug.browserRequired': 'Please specify your browser',
  'components.rightContent.reportBug.submitSuccess': 'Bug report submitted successfully!',
  'components.rightContent.reportBug.submitError': 'Failed to submit bug report. Please try again.',
  'components.rightContent.reportBug.invalidFileType': 'You can only upload image or video files!',
  'components.rightContent.reportBug.fileUploadSuccess': 'File "{fileName}" uploaded successfully!',
  'components.rightContent.reportBug.fileUploadError': 'Failed to upload file',
  'components.rightContent.reportBug.page.home': 'Home',
  'components.rightContent.reportBug.page.chat': 'Chat',
  'components.rightContent.reportBug.page.composer': 'Composer',
  'components.rightContent.reportBug.page.review': 'Review',
  'components.rightContent.reportBug.page.reference': 'Reference',
  'components.rightContent.reportBug.page.files': 'Files',
  'components.rightContent.reportBug.page.userProfile': 'User Profile',
  'components.rightContent.reportBug.page.other': 'Other',
  'components.rightContent.reportBug.browser.chrome': 'Chrome',
  'components.rightContent.reportBug.browser.safari': 'Safari',
  'components.rightContent.reportBug.browser.firefox': 'Firefox',
  'components.rightContent.reportBug.browser.edge': 'Edge',
  'components.rightContent.reportBug.browser.opera': 'Opera',
  'components.rightContent.reportBug.browser.brave': 'Brave',
  'components.rightContent.reportBug.browser.arc': 'Arc',
  'components.rightContent.reportBug.browser.other': 'Other',
  'components.rightContent.receiptModal.title': 'Thank you',
  'components.rightContent.receiptModal.description': 'Your report has been submitted.',
  'components.scribe.clickToStartRecording': 'Click to start recording',
  'components.scribe.failedToGetAuthToken': 'Failed to get authentication token',
  'components.scribe.failedToStartRecording': 'Failed to start recording',
  'components.searchPdfViewerWithHighlight.renderError': 'Failed to render PDF',
  'components.themeToggle.themeSectionLabel': 'THEME',
  'components.themeToggle.themeTeal': '🌊 Teal',
  'components.themeToggle.themeMaroon': '🍷 Maroon',
  'components.themeToggle.modeSectionLabel': 'MODE',
  'components.themeToggle.lightMode': 'Light',
  'components.themeToggle.darkMode': 'Dark',
  'components.themeToggle.themeSettingsTooltip': 'Theme settings',
  'components.whatsNewModal.title': "What's New",
  'components.whatsNewModal.intro':
    "We've introduced several new features to enhance your document review process:",
  'components.whatsNewModal.feature1.title': 'Improved Filtering: ',
  'components.whatsNewModal.feature1.description':
    'New audience and author filters to help you find your question lists faster.',
  'components.whatsNewModal.feature2.title': 'Ad-hoc Questions: ',
  'components.whatsNewModal.feature2.description': 'More flexible way to add questions on the fly.',
  'components.whatsNewModal.feature3.title': 'UI Enhancements: ',
  'components.whatsNewModal.feature3.description':
    'A cleaner, more intuitive interface for managing your {featureName}.',
  'components.whatsNewModal.upcomingFeatures.title': 'Upcoming Features',
  'components.whatsNewModal.upcomingFeatures.description':
    'Stay tuned for more updates, including collaborative reviews and advanced AI analytics.',
  'components.user.uidLabel': 'UID',
  'components.user.idCopiedMessage': 'ID copied!',
  'components.file.manager.fetchGroupError': 'Failed to fetch group: {message}',
  'components.file.manager.fetchFilesError': 'Failed to fetch files: {message}',
  'components.file.manager.breadcrumbRoot': 'route',
  'components.file.manager.breadcrumbBackUpLevel': 'back up-level',
  'components.file.manager.searchPlaceholder': 'search file or folder',
  'components.file.manager.uploadFileButton': 'Upload File',
  'components.file.manager.createFolderButton': 'Create Folder',
  'components.file.manager.enterButton': 'Enter',
  'components.file.manager.deleteFolderButton': 'Delete Folder',
  'components.file.manager.deleteFileButton': 'Delete File',
  'components.file.manager.uploadedByTime': 'Uploaded by: {username}, Uploaded Time: {createdAt}',
  'components.file.manager.folderNamePlaceholder': 'Folder Name',
  'components.file.filePreview.cannotPreview': 'This file type cannot be previewed',
  'components.file.documentSelector.sortNameAsc': 'Name (A-Z)',
  'components.file.documentSelector.sortNameDesc': 'Name (Z-A)',
  'components.file.documentSelector.sortNewestFirst': 'Newest first',
  'components.file.documentSelector.sortOldestFirst': 'Oldest first',
  'components.file.documentSelector.favourites': 'Favourites',
  'components.file.documentSelector.selectedCount': 'Selected ({count}):',
  'components.file.documentSelector.selectAllFilesInFolder': 'Select all files in {folderName}',
  'components.file.documentSelector.noFiles': 'No files',
  'components.file.documentSelector.folderAlt': 'folder',
  'components.file.documentSelector.fileAlt': 'file',
  'components.file.documentSelector.selectDocuments': 'Select document(s)',
  'components.file.documentSelector.selectOkText': 'Select',
  'components.file.fileTree.uploadFailed': '{fileName} upload failed',
  'components.file.fileTree.clickOrDragToUpload': 'Click or drag to upload',
  'components.file.fileTree.noFilesUploadedOrSelected': 'No file(s) uploaded or selected yet.',
  'components.file.selectContext.cannotDeleteDefaultContext':
    'You cannot delete the default context. Please set another context as default first.',
  'components.file.selectContext.contextDeleted': 'Context deleted',
  'components.file.selectContext.deleteContextFailed': 'Failed to delete context',
  'components.file.selectContext.enterContextNameWarning': 'Please enter a context name',
  'components.file.selectContext.contextCreated': 'Context created',
  'components.file.selectContext.cannotUnsetDefaultContext':
    'You cannot unset the default context. Please set another context as default first.',
  'components.file.selectContext.contextUpdated': 'Context updated',
  'components.file.selectContext.createContextFailed': 'Failed to create context',
  'components.file.selectContext.updateContextFailed': 'Failed to update context',
  'components.file.selectContext.selectContextPresetPlaceholder': 'Select context preset',
  'components.file.selectContext.defaultLabel': '(default)',
  'components.file.selectContext.deleteContextConfirmTitle': 'Delete this context?',
  'components.file.selectContext.deleteContextConfirmDescription': 'This cannot be undone.',
  'components.file.selectContext.addNewContextTooltip': 'Add new context',
  'components.file.selectContext.modifyContextInfoTooltip': 'Modify context info',
  'components.file.selectContext.newContextLabel': 'New context',
  'components.file.selectContext.editContextLabel': 'Edit context',
  'components.file.selectContext.contextTitlePlaceholder': 'Context title',
  'components.file.selectContext.setAsDefaultLabel': 'Set as default',
  'components.file.selectContext.contextSelectionTitle': 'Context selection',
  'components.file.selectContext.noContextSelected': 'No Context Selected',
  'components.appShell.logoutMenuItem': 'Logout',
  'components.appShell.unauthorized.title': 'This page is not meant for you',
  'components.appShell.unauthorized.backHome': 'Back Home',
  'components.appShell.promptLibrary.title': 'Prompt Library',
  'components.appShell.promptLibrary.noPromptsAvailable': 'No prompts available',
  'components.appShell.promptLibrary.copyTooltip': 'Copy prompt content',
  'components.appShell.promptLibrary.untitledPrompt': 'Untitled Prompt',
  'components.appShell.promptLibrary.copiedMessage': 'Prompt copied to clipboard!',
  'components.appShell.clipboard.title': 'Clipboard',
  'components.appShell.clipboard.copiedMessage': 'Copied!',
  'components.appShell.notFound.title': 'This page does not exists',
  'components.gettingStartedTour.tourTask.chat.title': 'Chat',
  'components.gettingStartedTour.tourTask.chat.duration': '~1 min',
  'components.gettingStartedTour.tourTask.search.title': 'Search',
  'components.gettingStartedTour.tourTask.search.duration': '~1 min',
  'components.gettingStartedTour.tourTask.scribe.title': 'Scribe',
  'components.gettingStartedTour.tourTask.scribe.duration': '~2 min',
  'components.gettingStartedTour.tourTask.review.title': 'Review',
  'components.gettingStartedTour.tourTask.review.duration': '~3 min',
  'components.gettingStartedTour.tourTask.playbook.title': 'Workstudio',
  'components.gettingStartedTour.tourTask.playbook.duration': '~2 min',
  'components.matrixPolling.processingStoppedMessage': 'Processing stopped',
  'components.matrixPolling.stopProcessingFailedMessage': 'Failed to stop processing',
  'components.appShell.noResponseError': 'None response! Please retry.',
  'components.appShell.requestError': 'Request error, please retry.',
  'components.appShell.requestFailedError': 'Request failed!',
  'components.composerService.socketErrorPrefix': 'Error: {message}',
  'components.composerService.sessionDisconnected':
    'Composer session disconnected due to another connection',
  'components.fileViewerWithToken.retrieveFailedError': 'Failed to retrieve file',
  'components.languageSwitcher.switchLanguageTooltip': 'Switch language',
  'components.crossOrgBadge.sharedByLabel': 'Shared by: {orgName}',
  'components.crossOrgBadge.externalOrganization': 'External Organization',
  'components.file.sharePoint.fromComputer': 'From this computer',
  'components.file.sharePoint.fromSharePoint': 'From SharePoint / OneDrive',
  'components.file.sharePoint.orAddFromSharePoint': 'or add from SharePoint / OneDrive',
  'components.file.sharePoint.account': 'Microsoft account',
  'components.file.sharePoint.useDifferentAccount': 'Use a different account',
  'components.file.sharePoint.disconnect': 'Disconnect',
  'components.file.sharePoint.disconnectConfirm': 'Disconnect your Microsoft account from A&GEL?',
  'components.file.sharePoint.disconnected': 'Microsoft account disconnected.',
  'components.file.sharePoint.popupBlocked':
    'Please allow pop-ups for A&GEL to pick files from SharePoint.',
  'components.file.sharePoint.consentDeniedTitle': 'SharePoint access not approved',
  'components.file.sharePoint.consentDenied':
    "SharePoint access wasn't approved. If your organisation requires IT admin approval, please ask your IT admin to approve A&GEL.",
  'components.file.sharePoint.copyApprovalLink': 'Copy approval link for your IT admin',
  'components.file.sharePoint.approvalLinkCopied': 'Approval link copied.',
  'components.file.sharePoint.connectFailed': "Couldn't connect to Microsoft. Please try again.",
  'components.file.sharePoint.reconnect': 'Please reconnect your Microsoft account.',
  'components.file.sharePoint.unsupportedType': "{name} isn't a supported file type here.",
  'components.file.sharePoint.tooLarge': '{name} is too large (max {max} MB).',
  'components.file.sharePoint.rejected': "{name} couldn't be added.",
  'components.file.sharePoint.downloadFailed':
    "Couldn't get {name} from SharePoint. Please try again or upload it from your computer.",
  'components.file.sharePoint.folderTooLarge':
    'This folder is too large to import at once (max {max} files). Please pick a smaller folder.',
  'components.file.sharePoint.chooserTitle': 'Pick files',
  'components.file.sharePoint.chooserMyFiles': 'My files',
  'components.file.sharePoint.chooserShared': 'Shared',
  'components.file.sharePoint.chooserFollowedSites': 'Followed sites',
  'components.file.sharePoint.chooserSearch': 'Search sites',
  'components.file.sharePoint.chooserName': 'Name',
  'components.file.sharePoint.chooserEmpty':
    "You don't follow any sites yet. Search for a site above.",
  'components.file.sharePoint.chooserLocked':
    'Only sites you follow or search for are shown. Ask your IT admin to approve A&GEL so you can browse every site.',
  'components.file.sharePoint.chooserLoading': 'Loading…',
  'components.file.sharePoint.chooserSelect': 'Select',
  'components.file.sharePoint.chooserCancel': 'Cancel',
};
